<template>
	<nav ref="menuNav" class="navbar-default navbar-static-side ">
		<div class="sidebar-collapse">

			<div class="menu-header">
				<div class="logo-area" @click="goToProfile">
					<img v-if="user.avatar && user.avatar.url" alt="image" class="img-circle w80" :src="user.avatar.url"/>
					<img v-else alt="image" class="img-circle w80" src="../../../common/assets/img/avatar.png"/>
				</div>
				<div class="text-area">
					<div class="nickname">
						{{user.nickname}}
					</div>
					<div class="role">
						{{user.role.name}}
					</div>
				</div>
			</div>

			<ul class="nav">
				<SideMenu v-for="(menu,index) in user.byMenus"  :key="index" :menu="menu"/>

			</ul>
		</div>
	</nav>
</template>
<script>
	import {mapGetters} from 'vuex'
	import SideMenu from "./SideMenu.vue"
	import PerfectScrollbar from "perfect-scrollbar";
	import "perfect-scrollbar/dist/css/perfect-scrollbar.css";

	export default {
		components: {
			SideMenu
		},
		data () {
			return {
				user: this.$store.state.user
			}
		},
		computed: {
			...mapGetters({
				config: "getConfig"
			})
		},
		methods: {
			goToProfile(){
				this.$router.push("/cgd/by/user/profile/" + this.user.id);
			},
			logout(){
				this.$router.push("/cgd/by/user/login");
			}
		},
		watch: {},
		mounted(){

			PerfectScrollbar.initialize(this.$refs.menuNav);

		}
	}
</script>




// WEBPACK FOOTER //
// Navigation.vue?08873617